import {
  API_ROUTES,
  API_ROUTE_PREFIX,
  IGetNextPageRouteRequestParams,
  resolveCmpForApiRequest,
} from "@tm/api-utils";
import { CONTEXT, LOB, PARTNER, PLATFORM } from "@tm/isomorphic-utils";
import { API_HTTP } from "../apiInstance";
import { setURLQueryParams } from "../setURLQueryParams";

export const getNextPageRouteDetails = async (
  reqData: IGetNextPageRouteRequestParams
): Promise<any> => {
  try {
    const {
      partner = PARTNER.MMT,
      headers,
      cmp,
      query,
      userSearchIntent,
      dvid,
      lob,
    } = reqData;
    const headerCmp = resolveCmpForApiRequest(cmp, query);
    const params = {
      lob: lob || LOB.STANDALONE,
      platform: PLATFORM.WEB,
      context: CONTEXT.STANDALONE_V2,
      isCountryCodesSupported: true.toString(),
      partner,
      ...query,
    };
    const urlParams = setURLQueryParams(params);

    let url;
    if (partner === PARTNER.MYPARTNER) {
      url = `${API_ROUTE_PREFIX}/${API_ROUTES.GET_NEXT_PAGE_ROUTE_MYPARTNER}${
        urlParams ? `?${urlParams}` : ""
      }`;
    } else {
      url = `${API_ROUTE_PREFIX}/${partner}/${API_ROUTES.GET_NEXT_PAGE_ROUTE}${
        urlParams ? `?${urlParams}` : ""
      }`;
    }
    const response = await API_HTTP.post(
      url,
      { userSearchIntent },
      {
        headers: { ...headers, cmp: headerCmp || "fallback", dvid },
      }
    );
    return { ...response, isNextPageCall: true };
  } catch (error) {
    console.error("Error", { error });
    throw error;
  }
};
